import React from 'react'
import { Plus, Minus, Maximize2, Minimize2, Crosshair } from 'lucide-react'
import { useTranslation } from 'react-i18next'

interface CanvasToolbarProps {
  onZoomIn: () => void
  onZoomOut: () => void
  onFit: () => void
  onToggleFullscreen: () => void
  isFullscreen: boolean
}

const Btn: React.FC<{
  onClick: () => void
  title: string
  children: React.ReactNode
}> = ({ onClick, title, children }) => (
  <button
    type="button"
    onClick={onClick}
    title={title}
    aria-label={title}
    className="w-8 h-8 flex items-center justify-center rounded bg-white/90 hover:bg-white border border-slate-200 text-slate-600 hover:text-slate-900 shadow-sm transition-colors"
  >
    {children}
  </button>
)

export const CanvasToolbar: React.FC<CanvasToolbarProps> = ({
  onZoomIn, onZoomOut, onFit, onToggleFullscreen, isFullscreen,
}) => {
  const { t } = useTranslation()
  return <div className="absolute bottom-3 right-3 flex flex-col gap-1.5 z-10">
    <Btn onClick={onZoomIn}  title={t('pentestUi.zoomIn')}><Plus className="h-4 w-4" /></Btn>
    <Btn onClick={onZoomOut} title={t('pentestUi.zoomOut')}><Minus className="h-4 w-4" /></Btn>
    <Btn onClick={onFit}     title={t('pentestUi.fit')}><Crosshair className="h-4 w-4" /></Btn>
    <Btn onClick={onToggleFullscreen} title={isFullscreen ? t('pentestUi.exitFullscreen') : t('pentestUi.fullscreen')}>
      {isFullscreen ? <Minimize2 className="h-4 w-4" /> : <Maximize2 className="h-4 w-4" />}
    </Btn>
  </div>
}
